(() => {
  console.log('Javascript de enviar formulario de registro de usuario');
  // While normally the will only be 1 create_customer form, there is one specific case in which there might be exactly 2.
  /**@type {NodeListOf<HTMLFormElement>} */
  const create_user_forms = document.querySelectorAll('#create_customer');
  if(!create_user_forms || create_user_forms.length == 0) {
    console.error('Create Customer Form Not Found.');
    return;
  }

  const APP_URL = window.Shopify.routes.root + "apps/upango-formulario/";
  //const APP_URL = window.Shopify.routes.root + "apps/alex-test/"

  function getFiscalInput(form) {
    return form.querySelector('#register-fiscal-code');
  }
  function showFiscalError(input) {
    input.setAttribute('aria-invalid', 'true');
    input.setAttribute('aria-describedby', 'register-fiscal-code-error');
    input.style.border = '2px solid red';
    input.focus();
  }
  function clearFiscalError(input) {
    input.removeAttribute('aria-invalid');
    input.removeAttribute('aria-describedby');
    input.style.border = '';
  }

  function validarNIF(nif) {
    if (typeof nif !== 'string') return false;
    nif = nif.toUpperCase().trim();

    // ===== DNI (8 dígitos + letra) =====
    const dniRegex = /^[0-9]{8}[A-Za-z]$/;
    if (dniRegex.test(nif)) {
        const letras = "TRWAGMYFPDXBNJZSQVHLCKE";
        const numero = parseInt(nif.slice(0, 8), 10);
        const letraEsperada = letras[numero % 23];
        console.log(letraEsperada);
        return nif[8] === letraEsperada;
    }

    // ===== NIE (X/Y/Z + 7 dígitos + letra) =====
    const nieRegex = /^[XYZ][0-9]{7}[A-Za-z]$/;
    if (nieRegex.test(nif)) {
        const letras = "TRWAGMYFPDXBNJZSQVHLCKE";
        const conversion = { X: '0', Y: '1', Z: '2' };
        const nieNumerico = conversion[nif[0]] + nif.slice(1, 8);
        const numero = parseInt(nieNumerico, 10);
        const letraEsperada = letras[numero % 23];
        // console.log(letraEsperada);
        return nif[8] === letraEsperada;
    }

    // ===== NIF Portugal (9 dígitos, módulo 11) =====
    const nifPortugalRegex = /^\d{9}$/; 
    if (nifPortugalRegex.test(nif)) {
        const firstDigit = parseInt(nif[0], 10);
        const validStartDigits = [1, 2, 5, 6, 8, 9]; // según práctica común
        if (!validStartDigits.includes(firstDigit)) return false;
        let sum = 0;
        for (let i = 0; i < 8; i++) {
        sum += parseInt(nif[i], 10) * (9 - i);
        }
        let controlDigit = 11 - (sum % 11);
        if (controlDigit >= 10) controlDigit = 0;
        // console.log(controlDigit);
        return controlDigit === parseInt(nif[8], 10);
    }

    // ===== CIF (ES): letra + 7 dígitos + control (dígito o letra) =====
    const cifEspRegex = /^[ABCDEFGHJNPQRSUVW][0-9]{7}[0-9A-J]$/; 
    if (cifEspRegex.test(nif)) {
        const letraInicial = nif[0];
        const cuerpo = nif.slice(1, 8);
        const controlChar = nif[8];
        let sumaPares = 0;
        for (let i = 1; i < cuerpo.length; i += 2) {
            sumaPares += parseInt(cuerpo[i], 10);
        }
        let sumaImpares = 0;
        for (let i = 0; i < cuerpo.length; i += 2) {
            const doble = 2 * parseInt(cuerpo[i], 10);
            sumaImpares += Math.floor(doble / 10) + (doble % 10);
        }
        const total = sumaPares + sumaImpares;
        const controlNum = (10 - (total % 10)) % 10;
        const controlLetra = "JABCDEFGHI"[controlNum];
        if ("PQRSNW".includes(letraInicial)) {
            // console.log(controlLetra);
            return controlChar === controlLetra;
        } else if ("ABEHJ".includes(letraInicial)) {
            // console.log(controlNum);
            return controlChar === String(controlNum);
        } else {
            // console.log('ALGUNO '+controlLetra+' '+controlNum);
            return controlChar === controlLetra || controlChar === String(controlNum);
        }
    }

    return false;
}

  /**
   * 
   * @param {FormData} formData 
   * @returns {Promise<boolean>}
   */
  async function sendForm(formData) {
    try {
      const data = new FormData();
      formData.forEach((value, key) => {
        console.log(value);
        console.log(key);
      });
      if(!formData.get('customer[user-profile]') || formData.get('customer[user-profile]') != "profile_numerosa") {
        return false;
      }
      data.append('shop', Shopify.shop);
      // Vamos a añadir los datos del formulario a nuestro formulario.
      data.append('Nombre', formData.get('customer[first_name]'));
      data.append('Apellidos', formData.get('customer[last_name]'));
      data.append('Email', formData.get('customer[email]'));
      data.append("Perfil de Cliente", formData.get('customer[user-profile]'))
      data.append('file', formData.get('customer[file-user-profile]'));
      data.append('Fecha de nacimiento del bebe', formData.get('customer[note][baby-birth-date]'));
      // Existe un PDF que debemos enviar.
      const req = await fetch(APP_URL + 'sendGenericForm', {
        method: 'POST',
        body: data
      });
      if(!req.ok) {
        console.error('Error al enviar el formulario.');
        console.error(req);
        return false;
      }
      const res = req.json();
      console.log(res);
      return true;
    } catch(error) {
      console.error('No se ha podido enviar los datos del formulario a la aplicación.');
      console.error(error);
      return false;
    }
  }

  create_user_forms.forEach((create_user_form) => {
    create_user_form.addEventListener('submit', async (event) => {
      event.preventDefault();
      event.stopImmediatePropagation();
      const fiscalInput = getFiscalInput(create_user_form);
      if (fiscalInput) {
        clearFiscalError(fiscalInput);
        const raw = (fiscalInput.value || '').trim().toUpperCase();
        if (raw && !validarNIF(raw)) {
          showFiscalError(fiscalInput);
          return;
        }
        if (raw) fiscalInput.value = raw;
      }

      await sendForm(new FormData(create_user_form));
      // After that we continue with the form submission.
      create_user_form.submit();
    });
  }, true);

})();